import type { TrackedTranslation } from '@ps/web-core-intl';
import { StarsButton } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

interface LimitsSelectButtonProps {
  variant: 'primary' | 'secondary';
  translation: TrackedTranslation;
  target?: string;
  onClick: () => void;
}

const LimitsSelectButton = ({ onClick, variant, translation, target }: LimitsSelectButtonProps) => {
  const form = useForm();

  const goToLimits = useCallback(() => {
    onClick();
    form.submit();
  }, [form, onClick]);

  const skipLimits = useCallback(() => {
    onClick();
    form.change('rmf.deposit.skip', true);
    form.submit();
  }, [form, onClick]);

  return (
    <StarsButton
      variant={variant}
      onClick={target ? goToLimits : skipLimits}
      translation={translation}
    />
  );
};

export default LimitsSelectButton;
